import { computed, ref } from 'vue'
import { useKeycloak } from '@lib/keycloak'
import { MiddlewareConnector } from '@middleware-connector'

const REQUIRED_ACTIONS = {
    // CONFIGURE_TOTP: 'CONFIGURE_TOTP',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
}

export const useCurrentUser = () => {
    const error = ref(null)
    const keycloak = useKeycloak()

    const errorMessage = computed(() => {
        if (!error.value) {
            return null
        }
        return error.value.response?.data?.detail?.userMessage || error.value.response?.data?.userMessage || error.value.message || error.value
    })

    const corporationScopes = computed(() => {
        return keycloak.tokenParsed.corporationScopes
    })

    const uuidCorporations = computed(() => {
        return keycloak.tokenParsed.corporations
    })

    const userName = computed(() => {
        const keycloakUser = keycloak.tokenParsed || {}
        const email = keycloakUser.email
        const userName = keycloakUser.preferred_username
        const name = keycloakUser.given_name && keycloakUser.family_name ? `${keycloakUser.given_name || ''} ${keycloakUser.family_name || ''}` : undefined

        return name || email || userName
    })

    const logout = () => {
        keycloak.logout()
    }

    const getCredentials = async () => {
        if (error.value) {
            error.value = null
        }
        return MiddlewareConnector.getAccountCredentials()
        .catch(err => {
            error.value = err
            return []
        })
    }

    const hasOtp = async () => {
        const credentials = await getCredentials()
        if (error.value) {
            return undefined
        }

        if (credentials.find(c => c.type === 'otp')) {
            return true
        }
        return false
    }

    const setUpdatePasswordAction = async () => {
        if (error.value) {
            error.value = null
        }
        return MiddlewareConnector.createAccountRequiredActions([ REQUIRED_ACTIONS.UPDATE_PASSWORD ])
        .catch(err => {
            error.value = err
            return []
        })
    }

    return {
        uuidCorporations,
        corporationScopes,
        userName,
        setUpdatePasswordAction,
        hasOtp,
        logout,
        errorMessage
    }
}

